'use strict';

const BaseModel = require('./base');

class TimeModel extends BaseModel {
  constructor() {
    super(...arguments);
  }

  toString() {
    return this.get('originalTime');
  }

  isEqual(otherTime) {
    return this.toString() === otherTime.toString();
  }
}

module.exports = TimeModel;
